import { Container, SvgIcon } from "@mui/material";
import React from "react";

import DocumentCheckIcon from "@heroicons/react/24/outline/DocumentCheckIcon";

const TableAcquireAction = () => {
  return (
    <SvgIcon
      color="primary"
      sx={{
        width: "1.35rem",
      }}
    >
      <DocumentCheckIcon />
    </SvgIcon>
  );
};

export default TableAcquireAction;
